module.exports = __webpack_public_path__ + "img/Free Computer Image on Unsplash.36f93ea8.png";